<template>
  <section id="stack" class="section">
    <div class="section-inner">
      <header v-reveal class="stack-head">
        <span class="eyebrow">02 — stack</span>
        <h2 class="section-title">Ferramentas do dia a dia</h2>
        <p class="section-lead">
          Do modelo à produção: as tecnologias que uso para construir produtos
          web e sistemas inteligentes de ponta a ponta.
        </p>
      </header>

      <div class="stack-grid">
        <article
          v-for="(group, i) in groups"
          :key="group.title"
          v-reveal="i * 70"
          class="stack-card"
          :class="{ 'stack-card--highlight': group.highlight }"
        >
          <div class="stack-card-head">
            <span class="stack-icon">
              <v-icon size="18">{{ group.icon }}</v-icon>
            </span>
            <h3 class="stack-card-title">{{ group.title }}</h3>
          </div>

          <ul class="chips">
            <li v-for="item in group.items" :key="item" class="chip mono">
              {{ item }}
            </li>
          </ul>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TechPage",

  data() {
    return {
      groups: [
        {
          title: "IA & LLMs",
          icon: "mdi-brain",
          highlight: true,
          items: [
            "LLMs",
            "Agentes de IA",
            "IA Generativa",
            "RAG",
            "Prompt Engineering",
            "OpenClaw",
            "Agno",
            "APIs de IA",
          ],
        },
        {
          title: "Frontend",
          icon: "mdi-application-brackets-outline",
          items: [
            "Vue.js 2/3",
            "Vuetify",
            "ReactJS",
            "React Native",
            "TypeScript",
            "JavaScript",
            "Tailwind CSS",
            "Sass",
            "Pinia",
            "Vuex",
          ],
        },
        {
          title: "Backend",
          icon: "mdi-server-network-outline",
          items: [
            "Node.js",
            "Express",
            "API Rest",
            "Swagger",
            "Google App Script",
            "Delphi",
          ],
        },
        {
          title: "Dados",
          icon: "mdi-database-outline",
          items: [
            "PostgreSQL",
            "MongoDB",
            "Prisma",
            "Firebase",
            "Firebird",
            "AWS RDS",
            "Studio 3T",
          ],
        },
        {
          title: "Infra & DevOps",
          icon: "mdi-cloud-cog-outline",
          items: [
            "Docker",
            "AWS",
            "GCP",
            "Terraform",
            "VPS",
            "Proxy reverso",
            "CI/CD",
          ],
        },
        {
          title: "Qualidade & Colaboração",
          icon: "mdi-check-decagram-outline",
          items: [
            "Jest",
            "Cypress",
            "Git / GitHub",
            "Postman",
            "Storybook",
            "Figma",
          ],
        },
      ],
    };
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
